// @flow
import SearchUrlFormatter from './formatters/SearchUrlFormatter';
import generateUrl from './utils/generateUrl';
import {
    QUERY,
    MIN_BATHROOMS,
    MIN_BEDROOMS,
    FILTER,
    PAGE
} from './models/SearchUrlParameters';

type Options = {
    hostname?: string
};

import type {SearchRequest, SearchRequestParam} from './models/SearchRequest';
const makeMinValueEnforcer = (searchRequest: SearchRequest) => (
    key: SearchRequestParam,
    minValue: number = 0
): SearchRequest => {
    return {
        ...(searchRequest[key] && parseInt(searchRequest[key], 10) > minValue
            ? {[key]: searchRequest[key]}
            : {})
    };
};
const pickCanonicalParams = (searchRequest: SearchRequest): SearchRequest => {
    const enforceMinValue = makeMinValueEnforcer(searchRequest);

    return {
        [QUERY]: searchRequest[QUERY] || '',
        [FILTER]: searchRequest[FILTER],
        ...enforceMinValue(MIN_BEDROOMS),
        ...enforceMinValue(MIN_BATHROOMS),
        ...enforceMinValue(PAGE, 1)
    };
};

export default function toCanonicalURL(
    searchRequest: SearchRequest,
    options: Options = {}
) {
    const {hostname} = options;

    const formatter = new SearchUrlFormatter();
    const canonicalSearchRequest = pickCanonicalParams(searchRequest);

    return generateUrl(
        hostname,
        formatter.format(canonicalSearchRequest, {canonicalizeKeywords: true})
    );
}
